import styles from "./alternativeLevel.module.css";
import InfoPopup from "../InfoPopup";

enum Level {
    BRONZE = "bronze",
    SILVER = "silver",
    GOLD = "gold",
    DRAFT = "draft"
}

interface Props {
    level: number;
    isPublished: boolean;
}

export default function AlternativeLevel({ level, isPublished }: Props) {
    const levelEnum = getLevelFromNumber(level);
    const levelStyle = styles[levelEnum];
    return (        <div className={`${styles.text} ${levelStyle}`}>
             {!isPublished && <p className={styles.notPublished}>NOT PUBLISHED</p>}
            <p>{levelEnum.toUpperCase()} {levelEnum != Level.DRAFT ? 'ALTERNATIVE' : ''}</p>
            <InfoPopup content={getInfoContent(levelEnum, isPublished)} />
        </div>
    );
}

function getLevelFromNumber(num: number): Level {
    if(num === 0) {
        return Level.DRAFT;
    }
    else if (num == 1) {
        return Level.BRONZE;
    } else if (num === 2) {
        return Level.SILVER;
    } else {
        return Level.GOLD;
    }
}

function getInfoContent(levelEnum: Level, isPublished: boolean): string {
    if (!isPublished) {
        return "This alternative is not yet published and is only visible to you and administrators.";
    }
    
    switch (levelEnum) {
        case Level.DRAFT:
            return "This is a draft alternative that is still being reviewed.";
        case Level.BRONZE:
            return "Alternatives that ChemSec has encountered while doing research. According to available information, solutions are safer. However, contact details and in-depth knowledge about the alternatives are lacking. Bronze alternatives can easily be upgraded to Silver if the producer provides additional information.";
        case Level.SILVER:
            return "After personal contact with the solution providers, ChemSec has examined the alternatives firsthand.";
        case Level.GOLD:
            return "Alternatives have a third-party hazard assessment verification that ensures the safety of the product.";
        default:
            return "Information about this alternative level.";
    }
}